import React, { useEffect, useState } from 'react';
import { MirrorEventType } from '../../../shared/types';
import { useSubscribe } from '../../../hooks';
import Path from '../../../components/Path/Path';
import { parseURI } from '../../../shared/utils/URI';
import { basename } from '../../../utils/path';
import { events$ } from '../events';
import styles from './List.less';
export default function List({ mirrors, onDelete }) {
    const [items, setItems] = useState([]);
    useEffect(() => setItems(mirrors.map(m => {
        const { path: remote } = parseURI(m.remote);
        const localName = basename(m.local);
        const remoteName = basename(remote);
        return {
            title: localName == remoteName ? localName : localName + ' ⇢ ' + remoteName,
            id: m.id,
            local: m.local,
            remote,
            recursive: m.recursive,
            del: m.del,
            filter: m.filter,
            syncing: false
        };
    })), [mirrors]);
    useSubscribe(() => events$.subscribe(event => {
        let item = items.find(({ id }) => id == event.id);
        if (item) {
            item.syncing = event.type == MirrorEventType.Syncing;
            setItems([...items]);
        }
    }), [items]);
    return React.createElement("ul", { className: styles.list }, items.map(item => React.createElement("li", { key: item.id },
        React.createElement("i", { className: "icon" }, "folder_eye"),
        React.createElement("article", null,
            React.createElement("h1", null, item.title),
            React.createElement("div", null,
                React.createElement("div", null,
                    React.createElement(Path, { path: item.local, type: 'local' }),
                    React.createElement(Path, { path: item.remote, type: 'remote' }),
                    React.createElement("b", null,
                        item.recursive
                            && React.createElement("span", null,
                                React.createElement("i", { className: "icon" }, "folder_copy"),
                                "Include subfolders"),
                        item.del &&
                            React.createElement("span", null,
                                React.createElement("i", { className: "icon" }, "delete"),
                                "Delete files"),
                        item.filter
                            && React.createElement("span", null,
                                React.createElement("i", { className: "icon", "data-tooltip": "Filter" }, "filter_alt"),
                                React.createElement("span", null,
                                    "Filter",
                                    React.createElement("span", null,
                                        item.filter?.text.length > 0 &&
                                            React.createElement("em", null,
                                                item.filter?.text,
                                                item.filter.matchCase &&
                                                    React.createElement("i", { className: 'icon' }, "match_case"),
                                                item.filter.wholeWord &&
                                                    React.createElement("i", { className: 'icon' }, "match_word"),
                                                item.filter.useRe &&
                                                    React.createElement("i", { className: 'icon' }, "regular_expression"),
                                                item.filter.folders &&
                                                    React.createElement("i", { className: 'icon' }, "folder"),
                                                item.filter.invert &&
                                                    React.createElement("i", { className: 'icon' }, "block")),
                                        (item.filter?.hidden || item.filter?.temporary) &&
                                            React.createElement("em", null,
                                                React.createElement("i", { className: 'icon' }, "visibility_off"),
                                                item.filter?.hidden && '.*',
                                                item.filter?.temporary && ' Tmp'),
                                        (item.filter?.uncommited || item.filter?.ignored) &&
                                            React.createElement("em", null,
                                                React.createElement("i", { className: 'icon' }, "graph_1"),
                                                item.filter?.uncommited && 'U',
                                                item.filter?.ignored &&
                                                    React.createElement("i", { className: 'icon' }, "visibility_off")))))),
                    item.syncing == true
                        ? React.createElement("mark", { className: "syncing" },
                            React.createElement("i", { className: "icon" }, "sync"),
                            " Syncing...")
                        : React.createElement("mark", { className: "synced" },
                            React.createElement("i", { className: "icon" }, "check_circle"),
                            " Synced")),
                React.createElement("div", null,
                    React.createElement("button", { className: "icon", onClick: () => onDelete(item.id) }, "delete")))))));
}
